import axios from 'axios'

const Axios = axios.create({
  baseURL: process.env.REACT_APP_API_URL
})

Axios.interceptors.request.use(
  async (request) => {
    let auth = localStorage.getItem('auth') || JSON.stringify({ token: '' })

    let token
    auth = JSON.parse(auth)

    if (auth) {
      token = auth?.token
      axios.defaults.headers.common.Authorization = `Bearer ${token}`
    }

    request.headers.authorization = `Bearer ${token}`
    return request
  },
  (error) => {
    return Promise.reject(error)
  }
)

export { Axios }
